function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_27917_30079)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.67 41.5C14.5312 41.5 16.04 39.9912 16.04 38.13C16.04 36.2688 14.5312 34.76 12.67 34.76C10.8088 34.76 9.3 36.2688 9.3 38.13C9.3 39.9912 10.8088 41.5 12.67 41.5Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.01 41.5C35.8712 41.5 37.38 39.9912 37.38 38.13C37.38 36.2688 35.8712 34.76 34.01 34.76C32.1488 34.76 30.64 36.2688 30.64 38.13C30.64 39.9912 32.1488 41.5 34.01 41.5Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.04 38.13H30.64",
  stroke: "#FF7A00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.37 38.13H38.16L41.52 37.27C42.09 37.12 42.49 36.61 42.49 36.01V35C42.49 34.76 42.4 34.52 42.23 34.35L41.95 34.06C41.77 33.87 41.67 33.62 41.67 33.36V32.79C41.67 32.27 41.37 31.79 40.9 31.57C39.63 30.97 38.28 30.55 36.89 30.32L33.49 29.76L27.67 26.43C26.56 25.8 25.3 25.46 24.03 25.46H17.93C16.55 25.46 15.18 25.8 13.96 26.46L8.87 29.2L6.54 29.49C5.8 29.58 5.24 30.21 5.24 30.96V32.3C5.24 32.67 5.15 33.04 4.98 33.37L4.75 33.81C4.58 34.15 4.49 34.52 4.49 34.89V35.9C4.49 36.54 4.91 37.1 5.52 37.28L6.86 37.68C7.82 37.97 8.3 38.12 9.3 38.12",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.8 12.41C27.8 11.04 26.69 9.92001 25.31 9.92001C25.24 9.92001 25.17 9.94001 25.1 9.94001C24.6 8.43001 23.19 7.32001 21.51 7.32001C19.41 7.32001 17.71 9.02001 17.71 11.12C17.71 12.79 18.79 14.19 20.28 14.7C20.28 14.77 20.26 14.85 20.26 14.92C20.26 16.34 21.41 17.5 22.84 17.5C24.27 17.5 25.42 16.35 25.42 14.92C25.42 14.91 25.42 14.89 25.42 14.88C26.74 14.83 27.8 13.74 27.8 12.4V12.41Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.09 8.61998C29.8025 8.61998 30.38 8.04243 30.38 7.32998C30.38 6.61753 29.8025 6.03998 29.09 6.03998C28.3776 6.03998 27.8 6.61753 27.8 7.32998C27.8 8.04243 28.3776 8.61998 29.09 8.61998Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.41 21.01C18.2439 21.01 18.92 20.3339 18.92 19.5C18.92 18.666 18.2439 17.99 17.41 17.99C16.576 17.99 15.9 18.666 15.9 19.5C15.9 20.3339 16.576 21.01 17.41 21.01Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.41 6.52C18.2439 6.52 18.92 5.84395 18.92 5.01C18.92 4.17605 18.2439 3.5 17.41 3.5C16.576 3.5 15.9 4.17605 15.9 5.01C15.9 5.84395 16.576 6.52 17.41 6.52Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.67 21.01L23.8 21.87",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.57 14.1L26.43 19.25",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.96 20.12L27.69 21.4",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.61 18.47L27.69 21.4",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.54 35.11C28.97 35.73 28.05 32.88 28.05 32.88C27.65 32.68 27.18 32.97 27.18 33.42V33.5C27.18 33.92 26.76 34.21 26.36 34.06L23.71 33.06C23.32 32.91 22.89 33.2 22.89 33.62C22.89 34.04 22.47 34.33 22.08 34.19L21.08 33.82C20.66 33.67 20.23 34 20.27 34.44C20.31 34.94 20.31 35.45 20.16 35.42C20.02 35.39 19.68 35.34 19.34 35.29C18.93 35.23 18.58 35.6 18.66 36.01L19.1 38.13",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.82 31.9L21.1 31.27",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.43 31.41L25.82 30.68",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.77 32.94L17.85 32.69",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.61 33.51L14.92 32.85",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_27917_30079"
}, /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 39,
  fill: "white",
  transform: "translate(4 3)"
})));
function SvgDirty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirty);
export default __webpack_public_path__ + "static/media/dirty.a4b38f6cc1994802347856aeb7884917.svg";
export { ForwardRef as ReactComponent };